import { Icon } from "@iconify/react/dist/iconify.js"
import AppDialog from "../../../components/Common/AppDialog"
import { Box, Chip, Grid } from "@mui/material";
import Label from "../../../components/Common/Label";
import Helpers from "../../../helpers/helpers";
import { useNavigate } from "react-router-dom";
import AppAttachmentDialog from "../../../components/Common/AppAttachmentDialog";
import { useState } from "react";

const AccessoriesInfoModal = ({ open, close, windowWidth, accessoryInfo }) => {
    const navigate = useNavigate();

    const [attachmentOpen, setAttachmentOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const renderInfoInGrid = (label, value, html = false) => {
        return (
            <Grid item container sm={12}>
                <Grid item lg={3} sm={6} xs={12} className="subheader-2">{label}</Grid>
                <Grid item lg={9} sm={6} xs={12} >{html ? <div dangerouslySetInnerHTML={{ __html: value }} /> : value}</Grid>
            </Grid>
        )
    }

    return (
        <>
            <AppDialog
                title={'Accessory Details'}
                open={open}
                close={close}
                positiveTitle={<div className="d-flex align-items-center"><Icon icon={'ri:pencil-line'} style={{ marginRight: 10 }} />Edit Accessory</div>}
                positiveButtonStyle={{ border: '1px solid #1D1B1B', color: '#1D1B1B', backgroundColor: 'white', width: windowWidth <= 768 ? '100%' : 'auto', borderRadius: 20 }}
                positivePress={() => navigate(`/edit-accessory/${accessoryInfo?.id}`)}
                negativeTitle={'Close'}
                negativePress={close}
                negativeButtonStyle={{ border: "1px solid #F9F9F9", backgroundColor: '#F9F9F9', color: '#808588', width: windowWidth <= 768 ? '100%' : 'auto', borderRadius: 20 }}
                isMobile={windowWidth <= 768 ? true : false}
            >
                <Grid container >
                    <Grid item lg={2} md={2} sm={12} xs={12} className="subheader-2 p-2">
                        <img alt="vehicle-img" src={accessoryInfo?.thumbnail_base64 || Helpers?.noImage} style={{ width: '100%', height: 120, objectFit: 'contain' }} />
                    </Grid>
                    <Grid item lg={10} md={10} sm={12} xs={12} py={2} px={1}>
                        <div className="text-bold font-size-18">{accessoryInfo?.name || ''}</div>
                        <div className="d-flex align-items-center my-2">
                            <span className="price-text">${accessoryInfo?.selling_price || ''}</span>
                            {/* <span className="subheader-2 mx-2">inst. ${'320'}/mth</span> */}
                        </div>
                        <Box className="align-items-center" sx={{ display: { lg: 'flex', md: 'block', sm: 'block', xs: 'block' } }}>
                            <Label.GeneralStatusLabel label={accessoryInfo?.status} list={Helpers.accessoryStatus} marginLeft={"0px"} />
                            <Box>
                                <span className="subheader-2">Listed On: </span>
                                {accessoryInfo?.created_at || '-'}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">Accessory Details</div>
                        </Grid>
                        {renderInfoInGrid('Brand', accessoryInfo?.brand_name || '-')}
                        {renderInfoInGrid('Category', accessoryInfo?.category_name || '-')}
                    </Grid>
                </div>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">Pricing</div>
                        </Grid>
                        {renderInfoInGrid('Selling Price', `$${accessoryInfo?.selling_price || '-'}`)}
                        {renderInfoInGrid('Promotion Price', `$${accessoryInfo?.promotion_price || '-'}`)}
                    </Grid>
                </div>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">Advertisement Details</div>
                        </Grid>
                        {renderInfoInGrid('Listing Title', accessoryInfo?.info?.title || '-')}
                        {renderInfoInGrid('Listing Description', accessoryInfo?.info?.description || '-', true)}
                    </Grid>
                </div>
                <div className="dashboard-card mt-3">
                    <Grid container spacing={2}>
                        <Grid item sm={12}>
                            <div className="text-bold">Media</div>
                        </Grid>
                        <Grid item container sm={12}>
                            <Grid item lg={3} sm={6} xs={12} className="subheader-2">Photos</Grid>
                            <Grid item container spacing={2} lg={9} sm={6} xs={12} >
                                {
                                    accessoryInfo?.images && accessoryInfo?.images?.find((item) => item?.type === 'thumbnail') &&
                                    accessoryInfo.images?.filter((item) => item?.type === 'thumbnail').map((item, index) => (
                                        <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
                                            <div style={{ position: 'relative', width: 'inherit', }}>
                                                <img
                                                    className="clickable"
                                                    src={item?.base64 || Helpers.noImage}
                                                    style={{ height: 100, width: '100%', objectFit: 'contain' }}
                                                    onClick={() => { setSelectedFile(item); setAttachmentOpen(true) }}
                                                />
                                                <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
                                                    <Chip label={"Thumbnail"} style={{ color: "white", border: "1px solid white", backgroundColor: "#D13536", height: "20px", marginLeft: 2, marginBottom: 2 }} />
                                                </div>
                                            </div>
                                        </Grid>
                                    ))
                                }
                                {
                                    accessoryInfo?.images?.length > 0 ? accessoryInfo?.images?.filter((item) => item.type === 'image')?.map((img, idx) => (
                                        <Grid item lg={3} md={4} sm={6} xs={12}>
                                            <img
                                                className="clickable"
                                                src={img?.base64 || Helpers?.noImage}
                                                style={{ width: '100%', height: 100, objectFit: 'contain' }}
                                                onClick={() => { setSelectedFile(img); setAttachmentOpen(true) }}
                                            />
                                        </Grid>
                                    )) : <Grid item lg={12} md={12} sm={12} xs={12}>No Images</Grid>
                                }
                            </Grid>
                        </Grid>
                        {renderInfoInGrid(
                            'Video URLs',
                            <ol className="text-bold p-0 px-2">
                                <li>Youtube: <span style={{ fontWeight: 400 }}>{accessoryInfo?.info?.youtube_url || '-'}</span></li>
                                <li>Facebook: <span style={{ fontWeight: 400 }}>{accessoryInfo?.info?.facebook_url || '-'}</span></li>
                                <li>Instagram: <span style={{ fontWeight: 400 }}>{accessoryInfo?.info?.instagram_url || '-'}</span></li>
                                <li>TikTok: <span style={{ fontWeight: 400 }}>{accessoryInfo?.info?.tiktok_url || '-'}</span></li>
                            </ol>
                        )}
                    </Grid>
                </div>
            </AppDialog>
            <AppAttachmentDialog
                open={attachmentOpen}
                close={() => setAttachmentOpen(false)}
                file={selectedFile?.base64}
                fileName={selectedFile?.attachment_name}
                filetype={selectedFile?.file_format}
            />
        </>
    )
}

export default AccessoriesInfoModal;